import {
    getAdobeAnalyticsEventObject,
    getAdobeAnalyticsCustomLinkObj,
    getAdobeAnalyticsContentObj

} from '../analytics/analyticsObject';
import { pushDatatoAdobeLayer } from '../analytics/pmiAdobeLog';
export const getCategoryBasedOnContentKeyId = (key) => {
    switch (key) {
        case "CTVideo":
            return 'articleVideo'
        case "CTCaseStudyText":
            return "caseStudy"
        case "CTArticleAudio":
            return 'articleAudio'
        case "CTTemplate":
            return "template"
        case "CTArticleWText":
            return "article"
        default:
            return "article"
    }
};
export const getUrlWithoutPathname = () => {
    return window.location.href;
};
export const getContentDetailsOnClick = (post, data, component) => {
    let subTopicsArray;
    let topicsArray;
    let industryArray = (post.industry && post.industry.length > 0) ? (post.industry).map(item => (item.name)) : ''
      if (post.isPublic && post.publishUntilDate && ((post.isPublic) && (new Date(post.publishUntilDate) > new Date()))) {
        topicsArray = (post.topics && post.topics.length > 0) ? (post.topics).map(item => item.length>0?',':"" + item.name) : ''
    }
    else {
        topicsArray = (post.topic && post.topic.length > 0) ? (post.topic).map(item => item.length>0?',':"" + item.name) : ''
    }
    if (post.isPublic && post.publishUntilDate && ((post.isPublic) && (new Date(post.publishUntilDate) > new Date()))) {
        subTopicsArray = (post.subTopics && post.subTopics.length > 0) ? (post.subTopics).map(item => ',' + item.name) : ''
    }
    else {
        subTopicsArray = (post.subTopic && post.subTopic.length > 0) ? (post.subTopic).map(item => ',' + item.name) : ''
    }
   
    let tagsArray = industryArray + topicsArray + subTopicsArray;
    tagsArray = tagsArray.replace(/^,/, '');
    tagsArray = tagsArray.replace(/,+/g, ',');
    let contEventObj = getAdobeAnalyticsEventObject(
        "card-cont-click",
        "card-cont-click",
        "cont-click"
    );
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(
        data,
        component,
        getUrlWithoutPathname()
    );
    let contObj = getAdobeAnalyticsContentObj({
        contClick: data,
        contID: post.contentKey,
        contLang: post.language,
        contName: post.title,
        contType: getCategoryBasedOnContentKeyId(post.contentType),
        contTags: tagsArray,
        contTopic: topicsArray?.length > 0 ? topicsArray.join(', ') : "",
        contSource: post.source,
        contIndustry: industryArray && industryArray.length > 0 ? industryArray[0] : 'not available',
    });
    pushDatatoAdobeLayer({
        onContClickData: { ...contEventObj, ...contObj },
        customLinkData: { ...customEventObj, ...customLObj },
        pageData: false,
        adobePushTracking: false,
    });
}
export default getCategoryBasedOnContentKeyId;
